// extracted by mini-css-extract-plugin
export var darkMode = "_24-0";